import { BaseRepository } from './base_repository';

const SESSION_DURATION_IN_MINUTES = 30;

export class SessionRepository extends BaseRepository {
	clearSession(): void {
		localStorage.removeItem('token');
		localStorage.removeItem('sessionExpiration');
	}

	startSession(token: string): void {
		this.clearSession();
		const expiration = new Date();
		expiration.setMinutes(
			expiration.getMinutes() + SESSION_DURATION_IN_MINUTES
		);
		localStorage.setItem('token', token);
		localStorage.setItem('sessionExpiration', expiration.toString());
	}
}
